module.exports = __webpack_public_path__ + "static/media/034-email-1.9a65761e.svg";